<template>
    <v-dialog
        v-model="dialog"
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
    >
        <v-card>
            <v-toolbar dark :color="options.color" dense flat>
                <v-toolbar-title
                    class="text-body-2 font-weight-bold grey--text"
                >
                    {{ title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text
                v-show="message"
                class="pa-4 black--text"
                v-html="message"
            />
            <v-container>
                <v-select
                    v-model="selectedvalue"
                    :items="choices"
                    :label="label"
                    :return-object="true"
                    dense
                    outlined
                    hide-details="true"
                    menu-props="offsetY"
                />
            </v-container>
            <v-card-actions class="pt-3">
                <v-spacer />
                <v-btn
                    v-if="!options.noconfirm"
                    color="grey"
                    text
                    class="body-2 font-weight-bold"
                    @click.native="cancel"
                >
                    {{ $t("common.cancel") }}
                </v-btn>
                <v-btn
                    color="primary"
                    class="body-2 font-weight-bold"
                    outlined
                    :disabled="selectedvalue == null"
                    @click.native="agree"
                >
                    {{ $t("common.ok") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
                resolve: null,
                reject: null,
                label: null,
                message: null,
                title: null,
                choices: [],
                selectedvalue: null,
                options: {
                    color: "grey lighten-3",
                    width: 400,
                    zIndex: 200,
                    noconfirm: false,
                },
            };
        },

        methods: {
            open(title, message, label, choices, options) {
                this.dialog = true;
                this.title = title;
                this.label = label;
                // while(this.choises.length > 0) this.choises.pop();
                this.choices = [];
                choices.forEach((c) => {
                    this.choices.push(c);
                });
                if (
                    this.selectedvalue &&
                    !this.choices.find(
                        (el) => el.value == this.selectedvalue.value,
                    )
                ) {
                    this.selectedvalue = null;
                }

                this.message = message;
                this.options = Object.assign(this.options, options);
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                });
            },
            agree() {
                this.resolve(true);
                this.dialog = false;
            },
            cancel() {
                this.resolve(false);
                this.dialog = false;
            },
        },
    };
</script>
